import React from 'react'
import type { User } from '@paintscout/api'
import { EstimatorAvatarSelect, useUsers } from '@paintscout/ui-business'
import { useLocation } from 'react-router-dom'

export interface CalendarEstimatorSelectProps {
  selectedUsers: User[]
  tab: 'calendar' | 'map' | 'schedule'
  onClick: (user: User, e: React.MouseEvent) => void
  onDoubleClick?: (allUsers: User[]) => void
  userFilter?: (user: User) => boolean
}

export default function CalendarEstimatorSelect({
  selectedUsers,
  userFilter,
  onClick,
  onDoubleClick
}: CalendarEstimatorSelectProps) {
  const { users, userPictures } = useUsers()
  const location = useLocation()

  const PROD_EVENT_USER_ROLES = ['sales', 'admin', 'crew', 'viewer', 'core', 'team']
  const SALES_EVENT_USER_ROLES = ['admin', 'sales', 'core']

  const activeUsers = (users || []).filter((user) => user.app_metadata?.active)
  const roleFilteredUsers = activeUsers.filter((user) => {
    const roles = user.app_metadata?.roles ?? []
    const include = location.pathname.includes('scheduling') ? PROD_EVENT_USER_ROLES : SALES_EVENT_USER_ROLES
    return roles.some((r) => include.includes(r))
  })
  const filteredUsers = userFilter ? roleFilteredUsers.filter(userFilter) : roleFilteredUsers

  if (filteredUsers.length < 2) {
    return null
  }

  return (
    <EstimatorAvatarSelect
      users={filteredUsers}
      selectedUsers={selectedUsers}
      userPictures={userPictures}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      tab="map"
    />
  )
}
